import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import React, {useContext} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {ServiceContext} from "./service_context";
import {submitService} from "../../services/service/service";

export function ConfirmationForm() {

  const {
    service,
    setService,
    setStep,
    modalOpen,
    setModalOpen,
    branchInfo,
    setLastDataRefresh
  } = useContext(ServiceContext);


  const handleOpen = () => setModalOpen(!modalOpen);

  const save = async (id) => {
    const data = {
      agent_id: service.agent_id,
      branch_id: branchInfo.id,
      topic: service.topic,
      challenge: service.challenge
    };
    let result;

    result = await submitService(data);

    if (result.status === 201) {
      const {person_service} = result.data;
      setService(person_service);
      setLastDataRefresh(Date.now())
      setStep("check")
    }
  };

  return (
    <>
      <Dialog size="xl" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen mt-20 bg-none">
        <DialogHeader className="bg-gray-800 rounded-2xl -mt-4">
          <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
            استعلام قیمت خدمات
          </Typography>
        </DialogHeader>

        <DialogBody className="flex flex-col w-full gap-4 rounded-2xl overflow-y-scroll">

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('agent')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {service.agent_name}
            </Typography>
          </div>

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('branch_title')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {branchInfo.branch_title}
            </Typography>
          </div>

          {branchInfo?.consensual &&
            <div className="grid flex-row grid-cols-1 w-full md:grid-cols-2 xxl:grid-cols-3 pb-2 border-b-2">
              <div className="mb-4 md:ml-3">
                <div className="flex flex-row border-l-2">
                  <Typography className="flex flex-col ml-2">
                    {Dict('min_service_price') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.min_price, true) + " ریال"}
                  </Typography>
                </div>
              </div>

              <div className="mb-4 md:mr-3">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('max_service_price') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.max_price, true) + " ریال"}
                  </Typography>
                </div>
              </div>
            </div>
          }
          {!branchInfo?.consensual &&
            <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
              <div className="flex flex-row">
                <Typography className="flex flex-col ml-2">
                  {Dict('service_price') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(branchInfo.price, true) + " ریال"}
                </Typography>
              </div>
            </div>
          }

          {branchInfo.side_cost &&
            <>
              <Checkbox
                checked={branchInfo.side_cost}
                label={
                  <Typography color="blue-gray" className="flex font-medium">
                    هزینه‌های جانبی
                  </Typography>
                }
              />
              <div className="mb-4 flex flex-col pb-2 border-b-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2 mb-4">
                    {Dict('side_cost_description') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {branchInfo.side_cost_description}
                  </Typography>
                </div>
              </div>
            </>
          }

          <div className="grid flex-row grid-cols-1 gap-6 mt-2 pb-2 border-b-2 md:grid-cols-2 xxl:grid-cols-3">
            {!branchInfo.period &&
              <div className="mb-4">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2 mb-4">
                    {Dict('service_day') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.day) + " روز"}
                  </Typography>
                </div>
              </div>
            }
            {branchInfo.period &&
              <>
                <div className="mb-4 border-l-2">
                  <div className="flex flex-row">
                    <Typography className="flex flex-col ml-2">
                      {Dict('min_service_day') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(branchInfo.min_day) + " روز"}
                    </Typography>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="flex flex-row">
                    <Typography className="flex flex-col ml-2">
                      {Dict('max_service_day') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(branchInfo.max_day) + " روز"}
                    </Typography>
                  </div>
                </div>
              </>
            }
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Input variant="standard"
                   label={Dict("service_topic")}
                   placeholder={Dict("service_topic")}
                   value={service.topic}
                   onChange={(e) => {
                     service.topic = e.target.value
                   }}
            />
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Textarea variant="standard"
                      label={Dict("challenge")}
                      placeholder={Dict("challenge")}
                      value={service.challenge}
                      onChange={(e) => {
                        service.challenge = e.target.value
                      }}
            />
          </div>


        </DialogBody>

        <DialogFooter className="space-x-2 textLeft">

          <div className=" flex flex-row mt-4 left-0 md:mt-0">
            <Button variant="text" color="gray" onClick={() => {
              setModalOpen(false)
            }}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" size="sm md:lg" onClick={save} className="ml-1">
              <span>استعلام قیمت</span>
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
